const defaultPalettes = [
    {
        name: "anni90",
        palette: [
            "#E4DCCF", //sfondo calendario
            "#002B5B",  //sfondo tutto
            "#EA5455", //sfondo sidebar
            "#000000", //testo scuro
            "#002B5B", //testo chiaro
            "#FF008E00",  //box shadow
            "#FF4C29"   //accent
        ],
        text_font: "tw_cen_mt, serif",
        title_font: "tw_cen_mt_bold_italic, serif",
        text_size: 14,
    },
    {
        name: "light",
        palette: [
            "#E8E8E8", //sfondo calendario
            "#dddddd",  //sfondo tutto
            "#ffffff", //sfondo sidebar
            "#000000", //testo scuro
            "#000000", //testo chiaro
            "#00000055",  //box shadow
            "#3A98B9"   //accent
        ],
        text_font: "tw_cen_mt, serif",
        title_font: "tw_cen_mt_bold_italic, serif",
        text_size: 14,
    },
    {
        name: "dark_blue",
        palette: [
            "#50577A", //sfondo calendario
            "#404258",  //sfondo tutto
            "#474E68", //sfondo sidebar
            "#F4EEE0", //testo scuro
            "#F4EEE0", //testo chiaro
            "#000000",  //box shadow
            "#D25380"   //accent
        ],
        text_font: "tw_cen_mt, serif",
        title_font: "tw_cen_mt_bold_italic, serif",
        text_size: 14,
    },
    {
        name: "dark",
        palette: [
            "#334756", //sfondo calendario
            "#082032",  //sfondo tutto
            "#2C394B", //sfondo sidebar
            "#F4EEE0", //testo scuro
            "#F4EEE0", //testo chiaro
            "#000000",  //box shadow
            "#FF4C29"   //accent
        ],
        text_font: "tw_cen_mt, serif",
        title_font: "tw_cen_mt_bold_italic, serif",
        text_size: 14,
    },
]

export default defaultPalettes